import React, { useState, useEffect } from "react";
import { useNavigate,useParams, useSearchParams } from "react-router-dom";
import { 
  Button, 
  Badge, 
  Table, 
  Dropdown, 
  Collapse, 
  ProgressBar, 
  Pagination as BSPagination, 
  Alert, 
  Spinner as BSSpinner,
  Card,
  Row,
  Col,
  Container,
  Form
} from "react-bootstrap"; // React Bootstrap imports
import {
  actualizarDatos,
  actualizarOt,
  deactivateOt,
  deleteById,
  reactivarOt,
  migrarSnapshotsDeOt,
  migrarSnapshotsOt,
  cerrarOtConNota,
  cancelarOtConNota,
} from "../api/common";
import moment from "moment";
import { Modales } from "../components/Modales";
import { SetOt } from "../components/Ot/SetOt";
import { paginate } from "../api/paginate";
import { capitalizeText } from "../utils/capitalizeText";
import Spinner from "../components/commons/Spinner";
import { estados, estadosicon, ESTADO_VARIANT } from "../components/Ot/settings";
import { Pagination } from "../components/commons/Pagination";
import { useAuth } from "../hooks/useAuth";
import { Modalcarga } from "../components/Modales/Modalcarga";
import { PARENT } from "../constants";
import SelectSearch from "../components/commons/SelectSearch";
import { PdfOt } from "../components/Ot/PdfOt";
import { ExcelExportHelper } from "../components/Ot/Excelstyle";
import { Actaentrega } from "../components/Pdfs/Actaentrega";
import { useTheme } from "../hooks/useTheme";
import ResponsiveTable from "../components/commons/ResponsiveTable";
import { Alertassw } from "../components/Alertas/Alertassw";
import { ObservacionOT, Observacioneq } from "../components/Equipo/Observacioneq";
import { Facturar } from "../components/Seguimiento/Facturar";
import ClienteSelect from "../components/commons/ClienteSelect";
import DateProgram from "../components/Ot/DateProgram";
import ValidarPermiso from "../components/Roles/ValidarPermiso";
import { APROVEEDITEM, CALIBRATE, CREATEACTAS, CREATEPROGRAMACION, PROGRAMOT } from "../components/Roles/ConstantRoute";
import { ContadoresOt } from "../components/Ot/IndicadoresOt";
import { FiltroestadosOt } from "../components/Ot/FiltroestadosOt";
import { Otselect } from "./Otselect";
import ProgramacionPorEquipo from "../components/Ot/ProgramacionPorEquipo";
// ✨ OPTIMIZED: New imports for spec 003
import { useOtList } from "../hooks/useOtList";
import { FiltrosOtOptimizados } from "../components/Ot/FiltrosOtOptimizados";
import { EditarOt } from "../components/Ot/EditarOt";
import ActasOTModal from "../components/Ot/ActasOTModal";
import { computarGrupoInfoMap } from "../utils/gruposEquipos";
import ModalDetalleAdicion from "../components/OtSelect/ModalDetalleAdicion";
import OtNotasModal from "../components/Ot/OtNotasModal";
import { FaComments } from "react-icons/fa";
import Swal from "sweetalert2";
import ModalReprogramar from "../components/Programaciones/ModalReprogramar";

moment.locale("es");

export const Ot = ({ filtroExterno = null } = {}) => {
  // Modal states (kept in component)
  const [spinnerMod, setSpinnerMod] = useState(false);
  const [otSelect, setOtSelect] = useState();
  const [modal, setModal] = useState(false);
  const[modalObs, setModalObs]=useState(false);
  const[modalFac,setModalFact]=useState(false);
  const[modalinfo,setModalInfo]=useState(false);
  const [ordendata, setOrdendata] = useState();
  const[accion, setAccion]=useState({
    tarea:'',
    titulo:''
  });
  const [estadomodal, setEstadomodal] = useState(false);
  const [modalReprogramar, setModalReprogramar] = useState(false);

  const [otInfo, setOtinfo] = useState({
    numero_orden: "",
    id: "",
  });
  // ✨ REDESIGN: Estado para controlar accordion activo
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [migratingOt, setMigratingOt] = useState(null);
  const [migratingAll, setMigratingAll] = useState(false);
  const [modalEditarOt, setModalEditarOt] = useState(false);
  const [otParaEditar, setOtParaEditar] = useState(null);
  // TIN-15 — Modal de listado de actas por OT
  const [showActasModal, setShowActasModal] = useState(false);
  const [otParaActas, setOtParaActas] = useState(null);
  // Detalle de equipo adicionado (columna "I" del acordeón de equipos)
  const [adicionModalEq, setAdicionModalEq] = useState(null);
  // Modal de notas de la OT (reemplaza observación)
  const [notasModalOt, setNotasModalOt] = useState(null);

  // Auth & theme hooks
  const { userData } = useAuth();
  const { size } = useTheme();
  const navigate = useNavigate();
  // Cuando Ot se monta dentro del wrapper de tabs (/Otlista/total), la ruta
  // no define `:id`, así que useParams devuelve undefined. Default a 'total'
  // para preservar el modo "listado general con filtros".
  const { id: idParam } = useParams();
  const id = idParam || 'total';
  const permisos =userData?.role?.permisos || []; // Lista de permisos del usuario;

  // ✨ OPTIMIZED: Replace 14 useState with useOtList hook
  const {
    results: otResults,
    pagination,
    loading,
    error,
    filters,
    updateFilter,
    resetFilters,
    changePage,
    perPage,
    changePerPage,
    refresh,
    pendingUpdates,
    hasPendingUpdates
  } = useOtList({
    initialPerPage: 20,
    initialFilters: id !== 'total' ? { _id: id } : {}
  });

  // Filtro externo (desde los tabs de seguimiento): cuando el usuario hace
  // click en una celda OT de /otlista/total tab Procesados/Finalizados/Aprobados,
  // el wrapper nos pasa `{ numeroOrden, _ts }`. Reseteamos los filtros y
  // aplicamos solo numeroOrden para dejar la OT referenciada en la lista.
  // El `_ts` fuerza re-ejecución aunque el mismo numeroOrden llegue dos veces.
  useEffect(() => {
    if (filtroExterno?.numeroOrden) {
      resetFilters();
      updateFilter('numeroOrden', filtroExterno.numeroOrden);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroExterno?._ts]);


  // ✨ OPTIMIZED: Helper functions (no changes needed)
  const alertaPermiso=()=>{
    Alertassw('error','PERMISO NO AUTORIZADO','Su rol no tiene habilitado este permiso, solicita a la persona autorizada la asignación')
  };

  const seguimiento = (orden) => {
    navigate(`/Seguimiento/${orden}?type=Ot`);
  };

  //Funcion para crear Hijo y abrir OT
  const continueOt = (ot) => {
    if(ValidarPermiso(CALIBRATE,permisos)!==-1){
      navigate(`/Ot/${ot._id}?orden=${ot.numeroOrden}&task=finalizar`);
    }else{
      alertaPermiso()
    }
  };

  const openOt = async (ot) => {
    if(ValidarPermiso(CALIBRATE,permisos)!==-1){
      setSpinnerMod(true);
      const ota = await actualizarDatos(
        "Ot",
        { ...ot, estado: "Abierta" },
        ot._id
      );
      if (ota.status === 200) {
        setSpinnerMod(false);
        refresh(); // ✨ OPTIMIZED: Use hook method
        navigate(`/Ot/${ot._id}?orden=${ot.numeroOrden}&task=finalizar`);
      }
    }else{
      alertaPermiso()
    }
  };

  //Funcion para programar OT
  const programOt = (ot) => {

    if(ValidarPermiso(PROGRAMOT,permisos)!==-1 ){
      setOtSelect(ot);
      setOtinfo({
        numero_orden: ot.numeroOrden,
        id: ot._id,
      });
      if(ot.estado === "Solicitud" ){
      setEstadomodal(true);
    }else 
      setModalReprogramar(true);

    }else{
      alertaPermiso()
    }
  };

  //Funcion para ir a la ruta indicada por el boton
  const funciones = {
    REQUESTED: "Solicitud",
    Solicitud: programOt,
    Programada: openOt,
    Abierta: continueOt,
    "Lista para Cerrar": "Cerrada",
    Cerrada: "Pagada",
    Pagada: "Entragada",
  };

  // ✨ OPTIMIZED: Removed useEffect for data loading (handled by useOtList)
  // ✨ OPTIMIZED: Removed handleSetFilters (replaced by updateFilter from hook)

  const createacta = (data) => {
    setOrdendata(data);
    setModal(true);
  };

  // TIN-15 — Abre el modal de listado de actas de una OT
  const verActas = (ot) => {
    setOtParaActas(ot);
    setShowActasModal(true);
  };

  const deleteOt = async (params) => {
    const { id: otId } = params;
    try {
      const data = await deleteById("Ot", otId);
      console.log(data);
      refresh(); // ✨ OPTIMIZED: Use hook method
    } catch (error) {
      console.log(error);
    }
  };

  // Cierra la OT exigiendo una nota de cierre obligatoria. La nota se crea
  // como tipo 'cierre' en el backend y queda inmutable (no se puede editar
  // ni eliminar) como evidencia del motivo.
  const closeOt = async (otId, descripcion) => {
    try {
      setSpinnerMod(true);
      await cerrarOtConNota(otId, descripcion);
      setSpinnerMod(false);
      Alertassw('success', 'OT cerrada', 'La OT fue cerrada y la nota se registró correctamente.');
      refresh();
    } catch (error) {
      setSpinnerMod(false);
      const msg = error?.response?.data?.error?.message
        || error?.response?.data?.detail
        || 'No se pudo cerrar la OT.';
      Alertassw('error', 'Error al cerrar OT', msg);
    }
  };

  // Cancela la OT (solo si está en Solicitud o Programada) con una nota
  // obligatoria. La nota queda tipo 'cancelacion' e inmutable; la OT pasa a
  // estado 'deactivated' (sale de los listados activos).
  const cancelarOt = async (otId, descripcion) => {
    try {
      setSpinnerMod(true);
      await cancelarOtConNota(otId, descripcion);
      setSpinnerMod(false);
      Alertassw('success', 'OT cancelada', 'La OT fue cancelada y la nota se registró correctamente.');
      refresh();
    } catch (error) {
      setSpinnerMod(false);
      const msg = error?.response?.data?.error?.message
        || error?.response?.data?.detail
        || 'No se pudo cancelar la OT.';
      Alertassw('error', 'Error al cancelar OT', msg);
    }
  };
 
  const Reactivar= async(ot)=>{
    try {
      setSpinnerMod(true)
      const resultOt = await reactivarOt('Ot',ot,ot._id)
      const ota = await actualizarDatos(
        "Ot",
        { ...ot, 
          estado: "Abierta",
          childs: ot.childs+1,
          visitas: ot.visitas+1
        },
        ot._id
      );
      refresh(); // ✨ OPTIMIZED: Use hook method
      setSpinnerMod(false)
      Alertassw('success','Orden activada correctamente aahora puedes abrirla')
    } catch (error) {
      console.log(error)
      setSpinnerMod(false)
      Alertassw('error','Error en la activacion de la Ot')
    }
  }
  const deactivateOts = async (params) => {
    const { id: otId } = params;
    try {
      await deactivateOt(otId);
      refresh(); // ✨ OPTIMIZED: Use hook method
    } catch (error) {
      console.log(error);
    }
  };

  /// Permite facturar la orden de trabajo
  const invoice=(ot)=>{
    setOrdendata(ot);
    setModalFact(true)
  }

  const handleDeleteOt = (id) => {
    Alertassw(
      "yes/no",
      "",
      "¿Esta seguro deseea eliminar la Orden? \n Esto eliminará la base de datos",
      "",
      0,
      deleteOt,
      { id }
    );
  };

  // Cerrar OT: la nota de cierre es obligatoria y queda inmutable en el modelo.
  const handleCloseOt = async (id) => {
    const { value: descripcion, isConfirmed } = await Swal.fire({
      title: '¿Cerrar Orden de Trabajo?',
      text: 'Describe el motivo del cierre. Esta nota queda registrada y no se puede eliminar.',
      input: 'textarea',
      inputPlaceholder: 'Motivo del cierre de la OT...',
      inputAttributes: { 'aria-label': 'Motivo del cierre', maxlength: 2000 },
      showCancelButton: true,
      confirmButtonText: 'Cerrar OT',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33',
      inputValidator: (value) => {
        if (!value || !value.trim()) return 'La nota de cierre es obligatoria';
        if (value.trim().length < 5) return 'Describe el motivo con al menos 5 caracteres';
        return null;
      }
    });
    if (!isConfirmed || !descripcion) return;
    await closeOt(id, descripcion.trim());
  };

  // Cancelar OT: solo visible en el dropdown cuando estado = Solicitud o
  // Programada. Nota de cancelación obligatoria e inmutable.
  const handleCancelarOt = async (id) => {
    const { value: descripcion, isConfirmed } = await Swal.fire({
      title: '¿Cancelar Orden de Trabajo?',
      text: 'Describe el motivo de la cancelación. Esta nota queda registrada y no se puede eliminar.',
      input: 'textarea',
      inputPlaceholder: 'Motivo de la cancelación...',
      inputAttributes: { 'aria-label': 'Motivo de la cancelación', maxlength: 2000 },
      showCancelButton: true,
      confirmButtonText: 'Cancelar OT',
      cancelButtonText: 'Volver',
      confirmButtonColor: '#d33',
      icon: 'warning',
      inputValidator: (value) => {
        if (!value || !value.trim()) return 'La nota de cancelación es obligatoria';
        if (value.trim().length < 5) return 'Describe el motivo con al menos 5 caracteres';
        return null;
      }
    });
    if (!isConfirmed || !descripcion) return;
    await cancelarOt(id, descripcion.trim());
  };

  // Abre el modal con las notas de la OT (reemplaza el ojo de "observación").
  const abrirNotas = (ot) => {
    setNotasModalOt(ot);
  };
  const infoOt=(ot)=>{
    setOrdendata(ot);
    setModalInfo(true)
  }

  const editarOt = (ot) => {
      setOtParaEditar(ot);
      setModalEditarOt(true);
  };

  const migrarTodosSnapshots = async () => {
    setMigratingAll(true);
    try {
      const result = await migrarSnapshotsOt();
      const { migrated = 0, skipped = 0, errors = 0 } = result?.data?.data || result?.data || {};
      Alertassw('success', 'Migración completada', `Migradas: ${migrated} | Omitidas: ${skipped} | Errores: ${errors}`);
      refresh();
    } catch (error) {
      Alertassw('error', 'Error en la migración', 'No se pudieron migrar los snapshots. Intenta nuevamente.');
    }
    setMigratingAll(false);
  };

  const handleDeactivatedOt = (id) => {
    Alertassw(
      "yes/no",
      "",
      "¿Esta seguro deseea desactivar la Orden?",
      "",
      0,
      deactivateOts,
      { id }
    );
  };

  return (
    <div>
      <Modalcarga estadoIn={spinnerMod} cambiarestadoIn={setSpinnerMod}>
        <Spinner />
      </Modalcarga>
      {/* ✨ OPTIMIZED: Check userData instead of oT */}
      {userData ? (
        <>
          <Modales
            estado={modal}
            cambiarestado={setModal}
            titulo={"Acta de entrega"}
          >
            <Actaentrega
              origen={"Ot"}
              setOrdendata={setOrdendata}
              dataot={ordendata}
              setModal={setModal}
              setRefresh={refresh} 
              refresh={refresh}
            />
          </Modales>
          <Modales
            estado={modalObs}
            cambiarestado={setModalObs}
            titulo={"Observación"}
          >
            <ObservacionOT cambiarestado={setModalObs} ordendata={ordendata} setRefresh={refresh} refresh={refresh} setSpinnerMod={setSpinnerMod}/>
          </Modales>
          <Modales
            estado={modalinfo}
            cambiarestado={setModalInfo}
            titulo={"Información de Ítems Cargados"}
          >
            <ContadoresOt ots={ordendata}/>

          </Modales>
          <Modales
            estado={modalFac}
            cambiarestado={setModalFact}
            titulo={"Facturar"}
          >
          <Facturar ordendata={ordendata} setModal={setModalFact} setRefresh={refresh} refresh={refresh}/>

          </Modales>

          {/* ✨ OPTIMIZED: Loading modal now uses hook loading state */}
          <Modalcarga
            estadoIn={loading}
            cambiarestadoIn={() => {}}
          >
            <Spinner />
          </Modalcarga>

          <div className="cuerpoContenido">
            <div className="cabecera d-flex justify-content-between align-items-center">
              <a className="titulo">Ordenes de trabajo</a>
              {/* ✨ OPTIMIZED: Refresh button with pending updates indicator */}
              <div className="d-flex gap-2">
                {userData?.role?.nombre === 'Admin' && (
                  <Button
                    variant="outline-warning"
                    size="sm"
                    onClick={migrarTodosSnapshots}
                    disabled={migratingAll}
                    title="Migrar snapshots de todas las OTs (solo Admin)"
                  >
                    {migratingAll ? (
                      <><BSSpinner animation="border" size="sm" className="me-1" /> Migrando...</>
                    ) : (
                      <><i className="bi bi-arrow-repeat me-1"></i> Migrar Snapshots</>
                    )}
                  </Button>
                )}
                <Button 
                  variant={hasPendingUpdates ? "warning" : "outline-primary"}
                  size="sm"
                  onClick={refresh}
                  disabled={loading}
                >
                  🔄 Actualizar
                  {hasPendingUpdates && (
                    <Badge bg="danger" className="ms-1">{pendingUpdates}</Badge>
                  )}
                </Button>
              </div>
          </div>

          {/* ✨ OPTIMIZED: Keep old FiltroestadosOt for status counters */}
          {id=="total" && userData?.role?.nombre!=="Cliente" ? (
            <FiltroestadosOt handleSetFilters={(e) => updateFilter(e.target.name, e.target.value)}/>
          ) : null}
          
          <hr className="linea" />

          {/* ✨ OPTIMIZED: New optimized filters component */}
          {userData?.role?.nombre!=="Cliente" && id=="total" ? (
            <FiltrosOtOptimizados 
              filters={filters}
              onFilterChange={updateFilter}
              onResetFilters={resetFilters}
            />
          ) : id !== "total" ? (
            <>
              <br/>
              <button type="button" 
               style={{ backgroundColor:"orange" }}
               className="btn btn-secondary btn-sm" 
               onClick={()=> navigate("/otlista/total")}
              >
                <strong>Mostrar todas las ordenes</strong>
              </button>
              <br/>
            </>
          ) : null}

            {userData?.role?.nombre!=="hasil" ? (
              <div className="flex">
                <div>
                  <input
                    type="checkbox"
                    className="checkbox"
                    onChange={(e) => {
                      const user = e.target.checked ? userData._id : undefined;
                      updateFilter('responsable', user); // ✨ OPTIMIZED: Use hook method
                    }}
                  />{" "}
                  Mis Ordenes de Trabajo
                </div>
              </div>
            ) : null}

            {/* ✨ REDESIGN: Table con React Bootstrap */}
            {loading ? (
              <div className="text-center my-5">
                <BSSpinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">Cargando órdenes de trabajo...</p>
              </div>
            ) : error ? (
              <Alert variant="danger">
                <Alert.Heading>Error al cargar datos</Alert.Heading>
                <p>{error}</p>
              </Alert>
            ) : otResults?.length === 0 ? (
              <Alert variant="info" className="text-center">
                <i className="bi bi-inbox fs-1 d-block mb-2"></i>
                <Alert.Heading>No hay órdenes de trabajo</Alert.Heading>
                <p>No se encontraron órdenes con los filtros seleccionados.</p>
              </Alert>
            ) : (
              <>
                <Table hover striped responsive size="sm" className="mt-3">
                  <thead className="table-dark">
                    <tr>
                      <th style={{width: '5%'}}>#</th>
                      <th style={{width: '7%'}}>No. OT</th>
                      <th style={{width: '4%'}}>P-C</th> {/** Un check si tiene propuesta comercial asociada */}
                      <th style={{width: '15%'}}>Cliente</th>
                      <th style={{width: '10%'}}>Ciudad</th>
                      <th style={{width: '10%'}}>Contacto</th>
                      <th style={{width: '8%'}}>F. Creación</th>
                      <th style={{width: '8%'}}>Responsable</th>
                      <th style={{width: '8%'}}>Estado</th>
                      <th style={{width: '10%'}}>Avance</th>
                      <th style={{width: '5%'}}>Obs.</th>
                      <th style={{width: '10%'}}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {otResults.map((ot, index) => {
                      const avance = Math.round(ot.avance * 100);
                      const revision = Math.round((ot.totalAprobado / ot.totalEq) * 100);
                      const entregaDenominator = Math.max(ot.totalEq - ot.canceledEq, 1);
                      const entrega = Math.min(100, Math.round((ot.totalEntrega / entregaDenominator) * 100));
                      const isExpanded = activeAccordion === ot._id;
                      
                      return (
                        <React.Fragment key={ot._id}>
                          <tr 
                            onClick={() => setActiveAccordion(isExpanded ? null : ot._id)}
                            style={{cursor: 'pointer'}}
                          >
                            <td className="align-middle">
                              <span className="text-primary fw-bold">
                                <i className={`bi bi-chevron-${isExpanded ? 'up' : 'down'} me-1`}></i>
                                { index + 1 }
                              </span>
                            </td>
                            <td className="align-middle">
                              <strong>{ot.numeroOrden}</strong>
                            </td>
                            <td className="align-middle">
                              {ot.propuestaComercial ? (
                                <i className="bi bi-check-lg text-success"></i>
                              ) : (
                                <i className="bi bi-x-lg text-danger"></i>
                              )}
                            </td>
                            <td className="align-middle">
                              {capitalizeText(ot.cliente?.nombre)} 
                            </td>
                            <td className="align-middle">
                              {capitalizeText(ot.cliente?.ciudad)}
                               <small className="text-muted d-block">{ot.cliente?.direccion}</small>
                            </td>
                            <td className="align-middle">
                              {capitalizeText(ot.cliente?.contacto)}
                              <small className="text-muted d-block">{ot.cliente?.telefono}</small>
                            </td>
                            <td className="align-middle">
                              {ot?.createdAt 
                                ? moment(ot?.createdAt).format("L") 
                                : <span className="text-muted">No definido</span>
                              }
                            </td>
                            <td className="align-middle">
                              {ot.responsable?.nombre
                                ? `${ot.responsable.nombre.charAt(0).toUpperCase()}. ${ot.responsable.apellido}`
                                : <span className="text-muted">No definido</span>
                              }
                            </td>
                            <td className="align-middle">
                              <Badge bg={ESTADO_VARIANT[ot.estado] || 'secondary'}>
                                {ot.estado}
                              </Badge>
                            </td>
                            <td className="align-middle">
                              <ProgressBar 
                                now={avance} 
                                label={`${avance}%`}
                                variant={avance < 30 ? 'danger' : avance < 70 ? 'warning' : 'success'}
                                style={{minWidth: '80px'}}
                              />
                              <small className="text-muted d-block mt-1">
                                Rev: {revision}% | Ent: {entrega}%
                              </small>
                            </td>
                            <td
                              className="align-middle text-center"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {(() => {
                                const cantidadNotas = Array.isArray(ot.notas) ? ot.notas.length : 0;
                                const tieneObsLegacy = Boolean(ot.observacion);
                                const total = cantidadNotas + (tieneObsLegacy ? 1 : 0);
                                return (
                                  <span
                                    role="button"
                                    title={total > 0 ? `Ver ${total} nota(s)` : 'Agregar nota'}
                                    onClick={() => abrirNotas(ot)}
                                    style={{ cursor: 'pointer', position: 'relative', display: 'inline-block', lineHeight: 1 }}
                                  >
                                    <FaComments className={total > 0 ? 'text-primary' : 'text-muted'} />
                                    {total > 0 && (
                                      <span
                                        style={{
                                          position: 'absolute',
                                          top: -6,
                                          right: -8,
                                          background: '#dc3545',
                                          color: '#fff',
                                          borderRadius: '50%',
                                          minWidth: 14,
                                          height: 14,
                                          padding: '0 3px',
                                          fontSize: '0.6rem',
                                          fontWeight: 700,
                                          lineHeight: '14px',
                                          textAlign: 'center',
                                          boxShadow: '0 0 0 1px #fff'
                                        }}
                                      >
                                        {total > 99 ? '99+' : total}
                                      </span>
                                    )}
                                  </span>
                                );
                              })()}
                            </td>
                            <td 
                              className="align-middle"
                              onClick={(e) => e.stopPropagation()}
                            >
                              {userData.role.nombre !== "Cliente" && (
                                <Dropdown>
                                  <Dropdown.Toggle variant="outline-secondary" size="sm" id={`dropdown-${ot._id}`}>
                                    <i className="bi bi-three-dots-vertical"></i>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    {//ValidarPermiso(CREATEPROGRAMACION, permisos) !== -1 &&
                                      !(ot.estado === "Cerrada" || ot.estado === "Cancelada" || ot.estado === "Facturar") && (
                                      <Dropdown.Item onClick={() => programOt(ot)}>
                                        <i className="bi bi-calendar2-week me-2"></i>
                                        {`${ot.estado === "Solicitud" ? "Programar" : "Reprogramar"}`}
                                      </Dropdown.Item>
                                    )}

                                    {(ot.estado === "Abierta" || ot.estado === "Programada") && (
                                      <Dropdown.Item onClick={() => funciones[ot.estado](ot)}>
                                        <i className={`bi ${estadosicon[ot.estado]} me-2`}></i>
                                        {estados[ot.estado]}
                                      </Dropdown.Item>
                                    )}
                                    
                                    {ot.finishedEq > ot.totalAprobado && ValidarPermiso(APROVEEDITEM, permisos) !== -1 && (
                                      <Dropdown.Item 
                                        onClick={() => navigate(
                                          `/Ot/${ot._id}?orden=${ot.numeroOrden}&task=revisar&totaleq=${ot.totalEq - ot.canceledEq}&aprobados=${ot.totalAprobado}`
                                        )}
                                      >
                                        <i className="bi bi-check2-all me-2"></i>
                                        Aprobar
                                      </Dropdown.Item>
                                    )}
                                    
                                    {ValidarPermiso(CREATEACTAS, permisos) !== -1 &&
                                      !(ot.estado === "Cerrada" || ot.estado === "Facturar") && (
                                      <Dropdown.Item onClick={() => createacta(ot)}>
                                        <i className="bi bi-files me-2"></i>
                                        Crear Acta
                                      </Dropdown.Item>
                                    )}

                                    <Dropdown.Item onClick={() => verActas(ot)}>
                                      <i className="bi bi-journal-text me-2"></i>
                                      Ver actas
                                    </Dropdown.Item>

                                    {ot.estado !== "Cerrada" && ot.estado !== "Cancelada" && (
                                      <Dropdown.Item onClick={() => editarOt(ot)}>
                                        <i className="bi bi-pencil-square me-2" />
                                        Editar OT
                                      </Dropdown.Item>
                                    )}
                                    <Dropdown.Divider />
                                    
                                    <Dropdown.Item onClick={() => seguimiento(ot.numeroOrden)}>
                                      <i className="bi bi-clock-history me-2"></i>
                                      Seguimiento
                                    </Dropdown.Item>
                                    
                                    {ot.estado === "Abierta" && (
                                      <Dropdown.Item onClick={() => PdfOt(ot.numeroOrden)}>
                                        <i className="bi bi-file-earmark-pdf me-2"></i>
                                        Descargar PDF
                                      </Dropdown.Item>
                                    )}
                                    {/** Boton para eliminar OT si estado es solicitud a traves de handle */}
                                    {ot.estado === "Solicitud" && (
                                      <Dropdown.Item onClick={() => handleDeleteOt(ot._id)}>
                                        <i className="bi bi-trash me-2"></i>
                                        Eliminar OT
                                      </Dropdown.Item>
                                    )}
                                    {/** Boton para cerrar Ot  si estado es diferente a solicitud traves de handle */}
                                    {ot.estado !== "Solicitud" && ot.estado !== "Cerrada" && ot.estado !== "Cancelada" && (
                                      <Dropdown.Item onClick={() => handleCloseOt(ot._id)}>
                                        <i className="bi bi-x-circle me-2"></i>
                                        Cerrar OT
                                      </Dropdown.Item>
                                    )}
                                    {/** Cancelar OT: solo cuando está en estado Solicitud o Programada. Pide nota obligatoria. */}
                                    {(ot.estado === "Solicitud" || ot.estado === "Programada") && (
                                      <Dropdown.Item onClick={() => handleCancelarOt(ot._id)}>
                                        <i className="bi bi-slash-circle me-2 text-danger"></i>
                                        Cancelar OT
                                      </Dropdown.Item>
                                    )}
                                    <Dropdown.Item onClick={() => DateProgram(ot)}>
                                      <i className="bi bi-file-earmark-spreadsheet me-2"></i>
                                      Exportar Excel
                                    </Dropdown.Item>
                                    
                                    <Dropdown.Item onClick={() => infoOt(ot)}>
                                      <i className="bi bi-info-square me-2"></i>
                                      Info
                                    </Dropdown.Item>
                                    
                                    {userData.role.nombre === "Admin" && ot.estado === 'Facturar' && (
                                      <>
                                        <Dropdown.Divider />
                                        <Dropdown.Item onClick={() => invoice(ot)}>
                                          <i className="bi bi-coin me-2"></i>
                                          Facturar
                                        </Dropdown.Item>
                                      </>
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              )}
                            </td>
                          </tr>
                          
                          {/* ✨ REDESIGN: Collapse para equipos */}
                          <tr>
                            <td colSpan="12" className="p-0 border-0">
                              <Collapse in={isExpanded}>
                                <div className="bg-light p-3">
                                  <div className="d-flex align-items-center justify-content-between mb-3">
                                    <h6 className="mb-0">
                                      <i className="bi bi-tools me-2"></i>
                                      Equipos de la OT ({ot.equipos?.length || 0})
                                    </h6>
                                    {//ot.equipos?.some(eq => !eq.snapshot?.item) && (
                                      <Button
                                        variant="warning"
                                        size="sm"
                                        disabled={migratingOt === ot._id}
                                        onClick={async () => {
                                          setMigratingOt(ot._id);
                                          try {
                                            await migrarSnapshotsDeOt(ot._id);
                                            Alertassw('success', 'Snapshots migrados', 'Los equipos legacy han sido actualizados');
                                            refresh();
                                          } catch (e) {
                                            Alertassw('error', 'Error', 'No se pudieron migrar los snapshots');
                                          } finally {
                                            setMigratingOt(null);
                                          }
                                        }}
                                      >
                                        <i className="bi bi-arrow-repeat me-1"></i>
                                        {migratingOt === ot._id ? 'Migrando...' : 'Migrar legacy'}
                                      </Button>
                                    //)
                                    }
                                  </div>
                                  <Table size="sm" bordered className="mb-0 bg-white" style={{tableLayout: 'fixed', wordBreak: 'break-word'}}>
                                    <thead className="table-secondary">
                                      <tr>
                                        <th style={{width: '4%', textAlign: 'center'}}>#</th>
                                        <th style={{width: '14%'}}>Item</th>
                                        <th style={{width: '9%'}}>Marca</th>
                                        <th style={{width: '9%'}}>Modelo</th>
                                        <th style={{width: '9%'}}>Serie</th>
                                        <th style={{width: '9%'}}>Ubicación</th>
                                        <th style={{width: '8%'}}>Puntos</th>
                                        <th style={{width: '5%'}}>Res</th>  {/**Resolución colocar un reloj analogico que indica a reolucion o division de escala*/} 
                                        <th style={{width: '8%'}}>Consec.</th>
                                        <th style={{width: '10%'}}>Estado</th>
                                        {/**Usuario  responsable del servicio icono de user con check centrado*/}
                                        <th style={{width: '9%'}}
                                        >
                                          <div className="bi bi-person-check me-1 text-center"></div>

                                        </th> 
                                        <th style={{width: '4%'}}>P</th>
                                        <th
                                          style={{width: '5%', textAlign: 'center'}}
                                          title="Ingresado al laboratorio · Grupo padre/dependiente · Equipo adicionado"
                                        >
                                          <i className="bi bi-diagram-3" />
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(() => {
                                        const grupoInfoMap = computarGrupoInfoMap(ot.equipos || []);
                                        return (ot.equipos || []).map((eq, index) => {
                                        const grupoInfo = grupoInfoMap.get(String(eq._id));
                                        const estaIngresado = Boolean(eq.fechaIngreso) ;
                                        return (
                                        <tr key={eq._id}>
                                          <td className="text-center">{index + 1}</td>
                                          <td style={{whiteSpace: 'normal'}}>
                                            <span
                                              className="text-primary cursor-pointer text-decoration-underline"
                                              onClick={() => navigate(`/perfilEq?_id=${eq.equipo?._id || eq.equipo}`)}
                                              style={{cursor: 'pointer'}}
                                            >
                                              {eq.snapshot?.item || <span className="text-muted">Sin ítem</span>}
                                            </span>
                                            {!eq.snapshot?.item && (
                                              <Badge bg="warning" text="dark" className="ms-2">
                                                Legacy
                                              </Badge>
                                            )}
                                          </td>
                                          <td style={{whiteSpace: 'normal'}}>{eq.snapshot?.marca || '-'}</td>
                                          <td style={{whiteSpace: 'normal'}}>{eq.snapshot?.modelo || '-'}</td>
                                          <td style={{whiteSpace: 'normal'}}>{eq.snapshot?.serial || '-'}</td>
                                          <td style={{whiteSpace: 'normal'}}> {/**Mostrar sede y ubicacion, sede arriba y debajo ubicacion */}
                                            <div className="d-flex flex-column">
                                            <strong>{eq.snapshot?.sede || '-'}</strong>
                                             <small>{eq.snapshot?.ubicacion || '-'}</small>
                                            </div>
                                            </td>
                                          <td style={{whiteSpace: 'normal'}}>{eq.snapshot?.puntos || '-'}</td>
                                          <td className="text-center">{eq.resolucion || '-'}</td>
                                          <td className="text-center">{eq.consecutivo}</td>
                                          <td style={{whiteSpace: 'normal'}}> {/**Quiero que el badge se ajuste al ancho de la columna ya que se mesta desbordando o saliendo de la columna y quisiera que se reduje el tamaño de la fuente y que l badge no me quede cortado*/}
                                            <Badge bg={eq.estado === 'Finalizado' ? 'success' : 'secondary'} className="w-100 text-truncate" style={{fontSize: '0.75rem'}}>
                                              {eq.estado}
                                            </Badge>
                                            {eq?.ingresado && eq.estado !== "Entregado" && (
                                              <i
                                                className="bi bi-pin-map-fill text-primary ms-2 cursor-pointer"
                                                onClick={() => navigate(
                                                  `/Ingresos/${eq._id}?orden=${ot.numeroOrden}&origen=equipo`
                                                )}
                                                style={{cursor: 'pointer'}}
                                              />
                                            )}
                                          </td>
                                          {/**nombre y paellido de del responsable y debajo la fecha fechaProcesado formateada dd/MM/yyyy */}
                                          <td className="text-center"> {}
                                            {eq.responsable?.nombre ? (
                                              <div className="d-flex flex-column align-items-center">
                                                <span>{`${eq?.responsable?.nombre.charAt(0).toUpperCase()}. ${eq?.responsable?.apellido}`}</span>
                                                <small className="text-muted">{eq.fechaProcesado ? new Date(eq.fechaProcesado).toLocaleDateString('es-ES') : '-'}</small>
                                              </div>
                                            ) : null}
                                          </td>

                                          {/** Mostrar icono de calendario si esta en progrmaacion es decir si tiene "programacionActual", mostrar icono de ubicacion si esta ingresado  es decir si tiene fechaIngreso y no tiene fechaSalida o mostrar los 2  */}
                                          <td className="text-center">
                                            {eq.programacionActual && (
                                              <i 
                                                className="bi bi-calendar2-week-fill text-warning me-1"
                                              />
                                            )}
                                          </td>
                                          <td className="text-center align-middle" style={{padding: '2px 1px'}}>
                                            <div
                                              className="d-flex flex-column align-items-center"
                                              style={{ gap: '2px', lineHeight: 1 }}
                                            >
                                              {/** Icono de ubicación si el equipo está ingresado sale azul si !eq.fechaSalida y color gris si eq.fechaSalida */}
                                              {estaIngresado && (
                                                <i
                                                  className={`bi bi-geo-alt-fill ${eq.fechaSalida ? 'text-muted' : 'text-primary'}`}
                                                  title={   `${eq.fechaSalida? 'Salido del laboratorio el ' + moment(eq.fechaSalida).format('DD/MM/YYYY') : 'Ingresado al laboratorio el ' + moment(eq.fechaIngreso).format('DD/MM/YYYY')}`}
                                                  style={{ fontSize: '0.8rem', lineHeight: 1 }}
                                                />
                                              )}
                                              {grupoInfo && (
                                                <span
                                                  className={grupoInfo.rol === 'padre' ? 'bg-primary text-white' : 'bg-info text-dark'}
                                                  style={{
                                                    display: 'inline-block',
                                                    fontSize: '0.55rem',
                                                    fontWeight: 700,
                                                    padding: '1px 3px',
                                                    lineHeight: 1.1,
                                                    whiteSpace: 'nowrap',
                                                    letterSpacing: '-0.03em',
                                                    borderRadius: '3px',
                                                    maxWidth: '100%',
                                                  }}
                                                  title={
                                                    grupoInfo.rol === 'padre'
                                                      ? `Padre del grupo ${grupoInfo.grupoNum}`
                                                      : `Dependiente ${grupoInfo.grupoNum}${grupoInfo.letra || ''} del grupo ${grupoInfo.grupoNum}`
                                                  }
                                                >
                                                  {grupoInfo.rol === 'padre'
                                                    ? `P${grupoInfo.grupoNum}`
                                                    : `D${grupoInfo.grupoNum}${grupoInfo.letra || ''}`}
                                                </span>
                                              )}
                                              {eq.adicion && (
                                                <i
                                                  className="bi bi-check-circle-fill text-success"
                                                  title="Ver detalle de adición"
                                                  style={{ cursor: 'pointer', fontSize: '0.8rem', lineHeight: 1 }}
                                                  onClick={(e) => { e.stopPropagation(); setAdicionModalEq(eq); }}
                                                />
                                              )}
                                            </div>
                                          </td>
                                        </tr>
                                        );
                                        });
                                      })()}
                                    </tbody>
                                  </Table>
                                </div>
                              </Collapse>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </Table>

                {/* ✨ REDESIGN: Pagination con React Bootstrap */}
                {otResults?.length > 0 && (
                  <div className="d-flex justify-content-between align-items-center mt-4">
                    {/* Selector de items por página */}
                    <div className="d-flex align-items-center">
                      <span className="me-2">Mostrar:</span>
                      <Form.Select 
                        size="sm" 
                        style={{ width: 'auto' }}
                        value={perPage}
                        onChange={(e) => changePerPage(Number(e.target.value))}
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </Form.Select>
                      <span className="ms-2 text-muted">
                        {pagination.total > 0 ? (
                          <>Mostrando {((pagination.page - 1) * pagination.perPage) + 1} - {Math.min(pagination.page * pagination.perPage, pagination.total)} de {pagination.total}</>
                        ) : 'Sin resultados'}
                      </span>
                    </div>

                    {/* Controles de páginas */}
                    {pagination.totalPages > 1 && (
                      <BSPagination className="mb-0">
                        {/* Botón Primera Página */}
                        <BSPagination.First 
                          disabled={pagination.page === 1} 
                          onClick={() => changePage(1)}
                        />
                        
                        {/* Botón Página Anterior */}
                        <BSPagination.Prev 
                          disabled={!pagination.hasPrevPage} 
                          onClick={() => changePage(pagination.page - 1)}
                        />
                        
                        {/* Mostrar primera página si estamos lejos */}
                        {pagination.page > 3 && (
                          <>
                            <BSPagination.Item onClick={() => changePage(1)}>1</BSPagination.Item>
                            {pagination.page > 4 && <BSPagination.Ellipsis disabled />}
                          </>
                        )}
                        
                        {/* Páginas cercanas a la actual */}
                        {[...Array(pagination.totalPages)].map((_, i) => {
                          const pageNum = i + 1;
                          if (
                            pageNum === pagination.page ||
                            (pageNum >= pagination.page - 2 && pageNum <= pagination.page + 2)
                          ) {
                            return (
                              <BSPagination.Item
                                key={pageNum}
                                active={pageNum === pagination.page}
                                onClick={() => changePage(pageNum)}
                              >
                                {pageNum}
                              </BSPagination.Item>
                            );
                          }
                          return null;
                        })}
                        
                        {/* Mostrar última página si estamos lejos */}
                        {pagination.page < pagination.totalPages - 2 && (
                          <>
                            {pagination.page < pagination.totalPages - 3 && <BSPagination.Ellipsis disabled />}
                            <BSPagination.Item onClick={() => changePage(pagination.totalPages)}>
                              {pagination.totalPages}
                            </BSPagination.Item>
                          </>
                        )}
                        
                        {/* Botón Página Siguiente */}
                        <BSPagination.Next 
                          disabled={!pagination.hasNextPage} 
                          onClick={() => changePage(pagination.page + 1)}
                        />

                        {/* Botón Última Página */}
                        <BSPagination.Last 
                          disabled={pagination.page === pagination.totalPages} 
                          onClick={() => changePage(pagination.totalPages)}
                        />
                      </BSPagination>
                    )}
                  </div>
                )}
              </>
            )}
            <div className="ordenblock"></div>

            <Modales
              estado={estadomodal}
              cambiarestado={setEstadomodal}
              titulo={`Programar Orden No : ${otInfo.numero_orden}`}
            >
              <ProgramacionPorEquipo
                cambiarestado={setEstadomodal}
                refresh={refresh}
                setRefresh={refresh}
                data={otSelect}
              />
            </Modales>

            <Modales
              estado={modalReprogramar}
              cambiarestado={setModalReprogramar}
              titulo={`Reprogramar Orden No : ${otInfo.numero_orden}`}
            >
              <ModalReprogramar
                show={modalReprogramar}
                onClose={() => setModalReprogramar(false)}
                onSuccess={() => { setModalReprogramar(false); refresh(); }}
                entidad="ot"
                idEntidad={otInfo.id}
              />
            </Modales>

            {otParaEditar && (
              <EditarOt
                ot={otParaEditar}
                show={modalEditarOt}
                onHide={() => setModalEditarOt(false)}
                onSaved={() => { setModalEditarOt(false); refresh(); }}
              />
            )}

            {/* TIN-15 — Listado de actas por OT */}
            <ActasOTModal
              show={showActasModal}
              onHide={() => { setShowActasModal(false); setOtParaActas(null); }}
              otId={otParaActas?._id}
              otConsecutivo={otParaActas?.numeroOrden}
            />

            {/* Detalle de equipo adicionado (columna "I" del acordeón) */}
            <ModalDetalleAdicion
              show={Boolean(adicionModalEq)}
              onHide={() => setAdicionModalEq(null)}
              equipo={adicionModalEq}
            />

            {/* Notas de la OT (reemplaza el campo observación legacy) */}
            <OtNotasModal
              show={Boolean(notasModalOt)}
              onHide={() => setNotasModalOt(null)}
              otId={notasModalOt?._id}
              numeroOrden={notasModalOt?.numeroOrden}
              onChanged={refresh}
            />
          </div>
        </>
      ) : (
        <Modalcarga estadoIn={loading} cambiarestadoIn={() => {}}>
          <Spinner />
        </Modalcarga>

      )}
    </div>
  );
};
